import * as React from 'react';
import { connect } from 'react-redux';
import Radium, { StyleRoot } from 'radium';
import {TShirtHeroLearnMoreHeader } from './TShirtHeroLearnMoreHeader';
import {browserHistory} from 'react-router';
import { TShirtHeroFooter } from './TShirtHeroFooter';
import { CSSProperties } from 'react';
import * as Tgcc from '../../tgccGlobal';

// Revised styles to include all updates and marketing suggestions
const pageStyles = {
    themeStyle: {
        backgroundColor: '#121212',
        color: '#E0E0E0',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        fontFamily: '"Roboto", sans-serif', // Ensure consistency with the registration page
    } as CSSProperties,
    contentStyle: {
        maxWidth: '800px',
        textAlign: 'center',
        marginBottom: '50px',
    } as CSSProperties,
    headlineStyle: {
        fontSize: '2.5rem',
        fontWeight: 'bold',
        margin: '20px 0',
    } as CSSProperties,
    textStyle: {
        fontSize: '1.4rem', // Adjust according to the new requirement if needed
        lineHeight: '1.8',
        marginBottom: '20px',
    } as CSSProperties,
    highlightStyle: {
        color: '#FFC107',
    } as CSSProperties,
    buttonStyle: {
        backgroundColor: '#007bff', // Updated to blue as suggested
        color: 'white',
        border: 'none',
        padding: '10px 20px',
        fontSize: '1rem',
        borderRadius: '5px',
        cursor: 'pointer',
        margin: '20px 0',
        ':hover': {
            backgroundColor: '#0056b3',
        },
    } as CSSProperties,
    sectionStyle: {
        marginTop: '30px',
        padding: '20px',
        borderRadius: '5px',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        color: '#E0E0E0',
    } as CSSProperties,
    listStyle: {
        textAlign: 'left',
        marginBottom: '20px',
    } as CSSProperties,
    listItemStyle: {
        marginBottom: '10px',
    } as CSSProperties,
    termsStyle: {
        fontSize: '0.8rem',
        cursor: 'pointer',
        marginTop: '20px',
    } as CSSProperties,
    emphasizedTextStyle: {
        fontSize: '1.6rem', // Even larger for more emphasis
        lineHeight: '2.0',
        fontWeight: 'bold', // Optional: if you want to make it bolder
        marginBottom: '20px',
    } as CSSProperties,
};

const termsStyles = {
    ...pageStyles, // Use the existing pageStyles for consistency
    termsContentStyle: {
        maxWidth: '800px',
        padding: '20px',
        textAlign: 'justify',
        backgroundColor: '#fff', // Light background for readability
        color: '#000', // Dark text for readability
        borderRadius: '5px',
        marginTop: '20px',
        lineHeight: '1.6',
        fontSize: '1rem',
    } as CSSProperties,
};

const legalDocumentStyle: CSSProperties = {
    backgroundColor: '#f8f9fa', // A soft gray background, common for legal documents
    color: '#212529', // Standard text color for readability on a light background
    border: '1px solid #dee2e6', // Borders for definition
    padding: '20px',
    marginBottom: '20px',
    lineHeight: '1.5',
    fontSize: '1rem',
    overflow: 'auto',
    marginTop: '65px',
    maxHeight: '75vh', // Set a max-height with overflow for long content
} as CSSProperties;

class _TShirtHeroTerms extends React.Component<Tgcc.BaseProps, any> {
    render() {
        return (
            <Radium.StyleRoot>
                <div style={termsStyles.themeStyle}>
                    <TShirtHeroLearnMoreHeader />
                    <div style={legalDocumentStyle}>
                        <h1 style={termsStyles.headlineStyle}>T-Shirt Hero Challenge Terms and Conditions</h1>
                        
                        {/* Introductory clause */}
                        <p style={termsStyles.textStyle}>
                            The T-Shirt Hero Challenge is a promotional contest organized by The Graphic Cow Company ("Organizer"). Participation in the Challenge is subject to the following Terms and Conditions ("Terms"). By participating, you agree to these Terms.
                        </p>
                        
                        {/* Eligibility */}
                        <h2 style={termsStyles.headlineStyle}>Eligibility</h2>
                        <p style={termsStyles.textStyle}>
                            The Challenge is open to all students associated with any university campus or collegiate group. The Organizer reserves the right to request proof of association with the university or group as needed. Employees of the Organizer and their immediate family members are not eligible to participate. The Challenge is void where prohibited by law.
                        </p>
                        
                        {/* Registration */}
                        <h2 style={termsStyles.headlineStyle}>Registration</h2>
                        <p style={termsStyles.textStyle}>
                            Participants must complete the registration process by March 31 to have a valid entry within the semester's drawing. This includes submitting valid contact information and agreeing to these Terms. An account manager may reach out to participants to confirm details.
                        </p>
                        
                        {/* Submissions */}
                        <h2 style={termsStyles.headlineStyle}>Submissions</h2>
                        <p style={termsStyles.textStyle}>
                            Submissions must be shared on Instagram or TikTok with the hashtag #TShirtHero and conform to the platforms' community standards. Inappropriate, offensive, or unlawful content will result in disqualification.
                        </p>
                        
                        {/* Prizes */}
                        <h2 style={termsStyles.headlineStyle}>Prizes</h2>
                        <p style={termsStyles.textStyle}>
                            The prize for the winning entry is $1000 worth of group apparel from the Organizer. Prizes are non-transferable and must be accepted as awarded. No cash or other substitution may be made, except by the Organizer, who reserves the right to substitute a prize with another prize of equal or greater value if the advertised prize is not available.
                        </p>
                        
                        {/* Judging */}
                        <h2 style={termsStyles.headlineStyle}>Judging</h2>
                        <p style={termsStyles.textStyle}>
                            Entries will be judged by a panel selected by the Organizer, whose decisions regarding the winners are final and binding. Judging will be based on creativity, originality, and adherence to the theme of heroism.
                        </p>
                        
                        {/* Intellectual Property */}
                        <h2 style={termsStyles.headlineStyle}>Intellectual Property</h2>
                        <p style={termsStyles.textStyle}>
                            By submitting an entry, participants grant the Organizer and its affiliates a royalty-free, irrevocable, perpetual license to use, reproduce, and distribute the submission in any media. Participants affirm they have the necessary rights to grant this license.
                        </p>
                        
                        {/* General Liability */}
                        <h2 style={termsStyles.headlineStyle}>General Liability</h2>
                        <p style={termsStyles.textStyle}>
                            The Organizer is not responsible for any incorrect or inaccurate information, whether caused by website users or by any equipment or programming associated with or utilized in the Challenge, and assumes no responsibility for any error, omission, interruption, deletion, defect, delay in operation or transmission, communications line failure, theft or destruction, or unauthorized access to the website.
                        </p>
                        
                        {/* Data Protection and Privacy */}
                        <h2 style={termsStyles.headlineStyle}>Data Protection and Privacy</h2>
                        <p style={termsStyles.textStyle}>
                            Any personal information received from participants will be used only for the purposes of administering the Challenge, awarding the prizes, and notifying you of future promotions and products. All personal information will be handled in accordance with the Organizer's Privacy Policy. Participants may opt-out of future communications at any time.
                        </p>

                        {/* Governing Law and Jurisdiction */}
                        <h2 style={termsStyles.headlineStyle}>Governing Law and Jurisdiction</h2>
                        <p style={termsStyles.textStyle}>
                            These Terms are governed by the laws of the state or country where the Organizer is headquartered, without regard to conflict of law doctrines. As a condition of participating in this Challenge, the participant agrees that any and all disputes that cannot be resolved between the parties, and causes of action arising out of or connected with this Challenge, shall be resolved individually, without resort to any form of class action, exclusively before a court located in the Organizer's headquarters' jurisdiction. Further, in any such dispute, under no circumstances shall the participant be permitted to obtain awards for, and hereby waives all rights to, punitive, incidental, or consequential damages, including reasonable attorney's fees, other than the participant's actual out-of-pocket expenses (i.e., costs associated with entering this Challenge). The participant waives all rights to have damages multiplied or increased.
                        </p>

                        {/* Changes to Terms and Conditions */}
                        <h2 style={termsStyles.headlineStyle}>Changes to Terms and Conditions</h2>
                        <p style={termsStyles.textStyle}>
                            The Organizer reserves the right to change these Terms at any time without prior notice. Any amendment will be integrated into these Terms and will become effective immediately upon being posted on the Challenge website.
                        </p>

                        {/* Acceptance of Terms and Conditions */}
                        <h2 style={termsStyles.headlineStyle}>Acceptance of Terms and Conditions</h2>
                        <p style={termsStyles.textStyle}>
                            By entering the Challenge, the participant signifies their agreement to these Terms and Conditions and any other documents published by the Organizer pertaining to the Challenge. This includes, without limitation, the acceptance of the decisions of the Organizer as final and conclusive.
                        </p>
                        </div>
                    <TShirtHeroFooter />
                    </div>
                    </Radium.StyleRoot>
                    );
                    }
                    }




const mapStateToProps = (state: Tgcc.GlobalState) => ({
    // State mapping if needed
});

export const TShirtHeroTerms = connect(mapStateToProps)(Radium(_TShirtHeroTerms));